import * as React from "react"
import { Box, Image } from "@chakra-ui/react"

import { TickerBar } from "./TickerBar"

export function Hero() {
  const handleScrollDown = () => {
    window.scrollBy({ top: 700, left: 0, behavior: "smooth" })
  }

  return (
    <Box position="relative" role="banner">
      <TickerBar />

      <Image
        alt="scroll naar beneden knop"
        src="/hero-arrow.png"
        width="200px"
        height="200px"
        position="absolute"
        bottom={{ base: -24, md: -24 }}
        ml="auto"
        mr="auto"
        right={0}
        left={0}
        onClick={handleScrollDown}
        cursor="pointer"
        zIndex={100}
        role="button"
        aria-label="Scroll naar beneden"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            handleScrollDown()
          }
        }}
      />

      <Box h={{ base: "85vh", md: "103vh" }} overflow="hidden">
        <Image
          src="/hero-cover.jpg"
          alt="Wat verzin je, schrijf je, maak je, copy-paste je?"
          w="100%"
          h="100%"
          objectFit="cover"
          objectPosition="bottom"
        />
      </Box>
    </Box>
  )
}
